<template>
  <v-menu offset-y>
    <template v-slot:activator={on}>
      <v-text-field hide-details v-bind:label="label" solo outlined flat dense append-icon="mdi-calendar-range" readonly v-on="on"/>
    </template>
    <v-date-picker no-title/>
  </v-menu>
</template>
<script>
export default {
  name: 'v-calendar',
  props: {
    label: String
  }
}
</script>